import React, { useState, useEffect } from "react";
import { signInWithGoogle, auth } from "./firebase";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

const db = getFirestore();

const ConsultantLogin = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    auth.onAuthStateChanged(async (currentUser) => {
      if (currentUser) {
        const userDoc = await getDoc(doc(db, "priest_users", currentUser.uid));
        if (userDoc.exists() && userDoc.data().role === "consultant") {
          navigate("/dashboard");
        } else {
          alert("Access denied. You are not a consultant.");
          // auth.signOut();
        }
      }
    });
  }, [navigate]);

  const handleLogin = async () => {
    await signInWithGoogle();
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h2 className="text-xl font-bold mb-4">Consultant Login</h2>
      <button onClick={handleLogin} className="bg-blue-500 text-white px-4 py-2 rounded">Sign in with Google</button>
    </div>
  );
};

export default ConsultantLogin;
